import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "titles-panel" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "content-panel" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", {
        style: _normalizeStyle({'padding-bottom': _ctx.titles.length * 5 + 'px'})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            onClick: ($event: any) => (_ctx.selectTitle(index))
          }, [
            _createElementVNode("span", {
              innerHTML: item.title
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3))
        }), 128))
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.selectedTitle !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h2", {
              innerHTML: _ctx.titles[_ctx.selectedTitle].title
            }, null, 8, _hoisted_7),
            _createElementVNode("p", null, _toDisplayString(_ctx.titles[_ctx.selectedTitle].content), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}